import { render, staticRenderFns } from "./validate-email.component.vue?vue&type=template&id=69850330&scoped=true&"
import script from "./validate-email.component.vue?vue&type=script&lang=ts&"
export * from "./validate-email.component.vue?vue&type=script&lang=ts&"
import style0 from "./validate-email.component.vue?vue&type=style&index=0&id=69850330&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69850330",
  null
  
)

export default component.exports